'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var label = _ref.label,
      icon = _ref.icon,
      active = _ref.active,
      _onMouseDown = _ref.onMouseDown;

  var styles = require('./Toolbars.scss');
  return _react2.default.createElement(
    'li',
    { className: styles.toolbarIcon + ' ' + (0, _classnames2.default)({ active: active }),
      onMouseDown: function onMouseDown(event) {
        event.preventDefault();_onMouseDown();
      }
    },
    label ? label : _react2.default.createElement('i', { className: icon })
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RichEditor/components/ToolbarIcon.js
// module id = 595
// module chunks = 0